// extracted by mini-css-extract-plugin
export default {"container":"IndexDetailsDialog-module__container__l4LFbRY","header":"IndexDetailsDialog-module__header__ojlFCeS","headerSubtext":"IndexDetailsDialog-module__headerSubtext__aRavG5i"};